import React, { useCallback, useContext, useMemo } from 'react'

import { Tag } from 'antd'
import { useSelector } from 'react-redux'

import { InternshipRequestFile, getCreatedAt, getOriginalName, getType, getTypeColor } from '../../../../utils/entities/internshipRequestFile'
import { OrderBy } from '../../../../utils/constants'
import { InternshipRequestFileModalContext } from '../../../../Providers/Forms/InternshipRequestFileModal'
import DataTable from '../../../../Components/antd/Tables/DataTable/DataTable'
import { DeleteAction, DownloadFile } from '../../../../Components/antd/Tables/DataTable/utils/actions'
import { selectUser } from '../../../../reducers/UserReducer'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { downloadInternshipDocument } from '../../../../utils/api/internshipDocument'
import { onError } from '../../../../utils/apiHelper'
import { TYPES } from '../../../../utils/entities/internshipDocument'

const InternshipRequestFilesTable = ({ conventionMandatory = false, disabled = false, data, individualInternshipRequest, loading, metadata, parameters, onDelete, onParametersChange, reload }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const { setSelectedFile } = useContext(InternshipRequestFileModalContext)

  const columns = useMemo(() => [
    { title: t('data_table.column_title.name'), orderBy: OrderBy.ORIGINAL_NAME, key: getOriginalName },
    {
      title: t('data_table.column_title.type'),
      orderBy: OrderBy.TYPE,
      key: f => <Tag color={getTypeColor(f)}>{t('internship_request_file.types.' + getType(f).toLowerCase())}</Tag>
    },
    { title: t('Date'), key: getCreatedAt }
  ], [t])

  const onFileDownload = useCallback(file => {
    try {
      downloadInternshipDocument(user, file)
    } catch (err) {
      onError(err)
    }
  }, [user.id])

  const actions = useMemo(() => [
    new DownloadFile({ onClick: onFileDownload }).build(),
    new DeleteAction({
      onDelete,
      disabled: d => disabled || d.deletable === false || (d.type.toLowerCase() === TYPES.CONVENTION && (d.locked || conventionMandatory))
    })
  ], [onDelete, user.id, onFileDownload, disabled, conventionMandatory])

  return (
    <DataTable
      actions={actions}
      columns={columns}
      data={data}
      loading={loading}
      metadata={metadata}
      parameters={parameters}
      onCreate={disabled ? undefined : () => setSelectedFile({ data: new InternshipRequestFile({ individualInternshipRequest }), callback: reload })}
      onParametersChange={onParametersChange}
    />
  )
}

export default InternshipRequestFilesTable
